import { render } from "./createOrganization.vue?vue&type=template&id=1c3db5be&scoped=true"
import script from "./createOrganization.vue?vue&type=script&lang=js"
export * from "./createOrganization.vue?vue&type=script&lang=js"

import "./createOrganization.vue?vue&type=style&index=0&id=1c3db5be&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3db5be"]])

export default __exports__